import FormatQuote from "@material-symbols/svg-500/rounded/format_quote-fill.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

export const FormatQuoteIcon = memo((props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: FormatQuote });
	return <Icon />;
});
